import { downloadFile } from "./downloadFile";

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);

  downloadFile(url, filename);

  URL.revokeObjectURL(url);
};
